import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { MaterialModule } from '../core/material.module';


@NgModule({
  imports: [
  ],
  exports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  declarations: [],
  providers: [],
})
export class SharedModulesModule {
}
